import { createTransform, Transform } from "redux-persist";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import localforage from "localforage";
import { OFFLINE_DATA_KEY, OFFLINE_QUEUE_KEY } from "./hybridStorage";

const secretKey: string = "secrets";

export const encryptTransform: Transform<any, any> = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState: any): string => {
    return AES.encrypt(JSON.stringify(inboundState), secretKey).toString();
  },
  // transform state being rehydrated
  (outboundState: any): any => {
    try {
      const bytes = AES.decrypt(outboundState, secretKey);
      return JSON.parse(bytes.toString(Utf8));
    } catch (err: any) {
      localStorage.clear();
      sessionStorage.clear();
      localforage.removeItem(OFFLINE_DATA_KEY);
      localforage.removeItem(OFFLINE_QUEUE_KEY);
    }
  },
);
